(function() {

  var PRODUCT_HANDLE = 'purahome-stainless-steel-tap-water-filter';

  var VARIANT_META = {
    '12 months (8 Filters)': {
      title: '2-Year\nSupply',
      subtitle: '(8 filters)',
      image: 'https://cdn.shopify.com/s/files/1/0917/6920/9148/files/1_17_91bbc02e-2ca6-46ab-b5b4-d7fd867f6347.png?v=1775768153'
    },
    '6 months (4 Filters)': {
      title: '1-Year\nSupply',
      subtitle: '(4 filters)',
      image: 'https://cdn.shopify.com/s/files/1/0917/6920/9148/files/2_18_c7ebb8f9-ed83-441f-ab16-0cb1954ac775.png?v=1775768153'
    },
    '3 months (2 Filters)': {
      title: '6-Month\nSupply',
      subtitle: '(2 filters)',
      image: 'https://cdn.shopify.com/s/files/1/0917/6920/9148/files/3_19_6af1cbee-e03e-4027-8fbb-275875c2f74f.png?v=1775768153'
    },
  };

  // Map currency codes to their correct symbols — hardcoded for reliability
  // across all browsers and locales
  var CURRENCY_SYMBOLS = {
    'AUD': '$', 'USD': '$', 'CAD': '$', 'NZD': '$', 'SGD': '$', 'HKD': '$',
    'GBP': '£', 'EUR': '€', 'JPY': '¥', 'CNY': '¥', 'INR': '₹',
    'CHF': 'Fr', 'SEK': 'kr', 'NOK': 'kr', 'DKK': 'kr', 'ZAR': 'R',
    'MXN': '$', 'BRL': 'R$', 'AED': 'د.إ', 'SAR': '﷼', 'THB': '฿',
    'MYR': 'RM', 'IDR': 'Rp', 'PHP': '₱', 'KRW': '₩', 'TRY': '₺',
  };

  function getCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
      ? window.Shopify.currency.active : 'AUD';
  }

  function getCurrencySymbol(currency) {
    return CURRENCY_SYMBOLS[currency] || '$';
  }

  function formatMoney(amount, currency) {
    try {
      var symbol = getCurrencySymbol(currency);
      var formatted = new Intl.NumberFormat(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
      return symbol + formatted;
    } catch(e) {
      return '$' + amount.toFixed(2);
    }
  }

  function formatMoneyNoDecimal(amount, currency) {
    try {
      var symbol = getCurrencySymbol(currency);
      var formatted = new Intl.NumberFormat(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount);
      return symbol + formatted;
    } catch(e) {
      return '$' + Math.round(amount);
    }
  }

  function calcSavePct(price, comparePrice) {
    if (!comparePrice || comparePrice <= price) return null;
    return Math.round((1 - price / comparePrice) * 100);
  }

  function calcSaveDollar(price, comparePrice) {
    if (!comparePrice || comparePrice <= price) return null;
    return comparePrice - price;
  }

  function updatePagePrices(variant, currency) {
    var price = variant.price;
    var comparePrice = variant.compare_price;
    var saveDollar = calcSaveDollar(price, comparePrice);

    // 1. Sale price
    document.querySelectorAll('.gp-price.gp-money.gp-text-instant').forEach(function(el) {
      if (!el.closest('#ph-variant-picker')) {
        el.textContent = formatMoney(price, currency);
      }
    });

    // 2. Compare price
    document.querySelectorAll('.gp-price.gp-product-compare-price.gp-text-instant').forEach(function(el) {
      if (!el.closest('#ph-variant-picker')) {
        if (comparePrice && comparePrice > price) {
          el.textContent = formatMoney(comparePrice, currency);
          el.style.display = '';
        } else {
          el.style.display = 'none';
        }
      }
    });

    // 3. SAVE badge
    var saveBadge = document.getElementById('product-badge-content');
    if (saveBadge && saveDollar) {
      saveBadge.textContent = 'Save ' + formatMoney(saveDollar, currency);
    }

    // 4. ATC button
    document.querySelectorAll('button[name="add"], .gp-btn-atc, [class*="add-to-cart"], [class*="atc"]').forEach(function(btn) {
      var text = btn.textContent || '';
      if (text.indexOf('$') > -1 || text.indexOf('£') > -1 || text.indexOf('€') > -1 || text.indexOf('¥') > -1) {
        btn.innerHTML = btn.innerHTML.replace(/[£€¥₹₩₺฿][\d,]+\.?[\d]*/g, formatMoney(price, currency))
                                     .replace(/\$[\d,]+\.?[\d]*/g, formatMoney(price, currency));
      }
    });

    // 5. Update URL
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());

    // 6. Update Shopify form inputs
    document.querySelectorAll('input[name="id"]').forEach(function(inp) {
      if (inp.type !== 'radio') {
        inp.value = variant.id;
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    document.querySelectorAll('[data-product-form], form[action*="/cart/add"]').forEach(function(form) {
      var input = form.querySelector('input[name="id"]');
      if (input) {
        input.value = variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // 7. Fire events
    document.dispatchEvent(new CustomEvent('variant:changed', {
      bubbles: true,
      detail: { variant: { id: parseInt(variant.id) } }
    }));
    window.dispatchEvent(new PopStateEvent('popstate', { state: {} }));
  }

  function selectVariant(variantId, variantTitle, container, allVariants, currency) {
    container.querySelectorAll('.ph-card').forEach(function(c) {
      c.classList.remove('ph-selected');
    });
    var targetCard = container.querySelector('[data-variant-id="' + variantId + '"]');
    if (targetCard) targetCard.classList.add('ph-selected');

    var meta = VARIANT_META[variantTitle] || {};
    var labelEl = document.getElementById('ph-selected-label');
    if (labelEl) {
      labelEl.textContent = (meta.title || variantTitle).replace('\n', ' ') + ' ' + (meta.subtitle || '');
    }

    var variant = null;
    allVariants.forEach(function(v) { if (v.id == variantId) variant = v; });
    if (variant) updatePagePrices(variant, currency);
  }

  function buildCards(variants, currency, container) {
    container.innerHTML = '';

    variants.forEach(function(variant) {
      var meta = VARIANT_META[variant.title] || { title: variant.title, subtitle: '', image: null };
      var titleLines = meta.title.split('\n');
      var savePct = calcSavePct(variant.price, variant.compare_price);

      var card = document.createElement('div');
      card.className = 'ph-card';
      card.setAttribute('data-variant-id', variant.id);
      card.setAttribute('data-variant-title', variant.title);

      if (savePct) {
        var badge = document.createElement('div');
        badge.className = 'ph-card-badge';
        badge.textContent = 'SAVE ' + savePct + '%';
        card.appendChild(badge);
      }

      var imgWrap = document.createElement('div');
      imgWrap.className = 'ph-card-img-wrap';
      var imgSrc = meta.image || (variant.featured_image && variant.featured_image.src) || null;
      if (imgSrc) {
        var imgEl = document.createElement('img');
        imgEl.className = 'ph-card-img';
        imgEl.src = imgSrc;
        imgEl.alt = variant.title;
        imgWrap.appendChild(imgEl);
      } else {
        var placeholder = document.createElement('div');
        placeholder.className = 'ph-card-img-placeholder';
        imgWrap.appendChild(placeholder);
      }
      card.appendChild(imgWrap);

      var titleEl = document.createElement('div');
      titleEl.className = 'ph-card-title';
      titleEl.innerHTML = titleLines.join('<br>');
      card.appendChild(titleEl);

      var subtitleEl = document.createElement('div');
      subtitleEl.className = 'ph-card-subtitle';
      subtitleEl.textContent = meta.subtitle;
      card.appendChild(subtitleEl);

      var pricesEl = document.createElement('div');
      pricesEl.className = 'ph-card-prices';
      if (variant.compare_price && variant.compare_price > variant.price) {
        var compareEl = document.createElement('span');
        compareEl.className = 'ph-price-compare';
        compareEl.textContent = formatMoneyNoDecimal(variant.compare_price, currency);
        pricesEl.appendChild(compareEl);
      }
      var currentEl = document.createElement('span');
      currentEl.className = 'ph-price-current';
      currentEl.textContent = formatMoneyNoDecimal(variant.price, currency);
      pricesEl.appendChild(currentEl);
      card.appendChild(pricesEl);

      card.addEventListener('click', function() {
        selectVariant(variant.id, variant.title, container, variants, currency);
      });

      container.appendChild(card);
    });

    if (variants.length > 0) {
      selectVariant(variants[0].id, variants[0].title, container, variants, currency);
    }
  }

  function init() {
    var container = document.getElementById('ph-cards-container');
    if (!container) return;

    var currency = getCurrency();

    if (window.variantData && Array.isArray(window.variantData) && window.variantData.length > 0) {
      var variants = [];
      var productVariants = null;

      if (window.__st && window.__st.p && window.__st.p.variants) {
        productVariants = window.__st.p.variants;
      }

      window.variantData.forEach(function(vd, idx) {
        var title = '';
        var featuredImage = null;

        if (productVariants) {
          productVariants.forEach(function(pv) {
            if (pv.id == vd.id) {
              title = pv.title || pv.option1 || '';
              featuredImage = pv.featured_image || null;
            }
          });
        }

        if (!title) {
          var keys = Object.keys(VARIANT_META);
          title = keys[idx] || '';
        }

        variants.push({
          id: vd.id,
          title: title,
          featured_image: featuredImage,
          price: vd.price,
          compare_price: vd.compare_price
        });
      });

      buildCards(variants, currency, container);
      return;
    }

    // Fallback fetch
    fetch('/products/' + PRODUCT_HANDLE + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        var priceMap = {};
        if (window.variantData) {
          window.variantData.forEach(function(v) { priceMap[v.id] = v; });
        }
        var merged = product.variants.map(function(v) {
          var p = priceMap[v.id] || {};
          return {
            id: v.id,
            title: v.title,
            featured_image: v.featured_image,
            price: p.price !== undefined ? p.price : v.price / 100,
            compare_price: p.compare_price !== undefined ? p.compare_price : (v.compare_at_price ? v.compare_at_price / 100 : null),
          };
        });
        buildCards(merged, currency, container);
      })
      .catch(function(err) {
        container.innerHTML = '<div class="ph-loading">Could not load options. Please refresh.</div>';
        console.error('[PH] fetch error:', err);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();